import { useMutation } from '@tanstack/react-query';

import { initializeChat } from '../services/chat';

import type { InitializeChatResponse } from '../types/chat';

export function useInitializeChat() {
  return useMutation<InitializeChatResponse>({
    mutationFn: initializeChat
  });
}
